<script>
import SearchResultsTab from '@phoenix/mixins/components/search/SearchResultsTab';
import { PhxGridLayout } from '@sg/src/View/Components/Atoms/GridLayout';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';
import { PhxsgLoader } from '@sg/src/View/Components/Atoms/Loader';

export default {
  components: {
    PhxsgButton,
    PhxGridLayout,
    PhxsgLoader,
  },

  mixins: [SearchResultsTab],

  watch: {
    isLoading: {
      handler(value) {
        this.setButtonLoading(value);
      },
      immediate: true,
    },
  },

  methods: {
    setButtonLoading(isLoading = true) {
      if (isLoading) {
        Toolkit.helpers.buttons.addLoadingState(this.$refs.loadMoreButton);
      } else {
        Toolkit.helpers.buttons.removeLoadingState(this.$refs.loadMoreButton);
      }
    },
  },
};
</script>

<template>
  <div v-if="isGlobalLoading" class="center center--and-text">
    <PhxsgLoader />
  </div>

  <template v-else-if="hasResults">
    <phx-grid-layout class="mixed-grid" grid-spacing="4" :center-spacing="null">
      <slot />
    </phx-grid-layout>

    <div v-if="displayLoadMore" class="mt-4 center center--spacing-4">
      <div class="form-actions switcher switcher--spacing-2">
        <PhxsgButton ref="loadMoreButton" variant="fade" @click="onLoadMoreClick">
          {{ $t('Button.loadMore') }}
        </PhxsgButton>
      </div>
    </div>
  </template>
</template>
